import $ from 'jquery';
import pageScripts from './pages';

import 'what-input';

// Node modules
require('slick-carousel');
const objectFitImages = require('object-fit-images');
const inject = require('svg-inject');

$(document).ready(function () {
	// Require all components here
	require('./components/foundation');
	require('./components/logo-slider');
	require('./components/article-slider');
	require('./components/menu-search');
	require('./components/archive-filters');
	require('./components/toggle-third-menu');

	// Initialize object-fit-images
	objectFitImages();

	let svgs = document.querySelectorAll('img[src$=".svg"]');

	for (let i = 0; i < svgs.length; i++) {
		inject(svgs[i], function(err, svg) {
			if (err) throw err;
			// do additional things with `svg` here if you like.
		});
	}

	document.body.className.replace(/-/g, '_').split(/\s+/).forEach(cls => {
		pageScripts[cls] && pageScripts[cls]();
	});
});
